import styled, { css } from 'styled-components';

/**
 * Wrapper used to keep hover events working for disabled options,
 * so tooltips can still be shown.
 */
export const DomainHandleOptionWrapper = styled.div`
  display: block;
`;

/**
 * Main option container.
 */
export const DomainHandleOption = styled.div`
  padding: var(--xs-padding) var(--sm-padding);
  background-color: var(--body-bg);
  text-align: left;
  border-bottom: 1px solid var(--bg-1);

  :hover {
    background-color: var(--bg-1);

    * {
      color: var(--text) !important;
    }
  }

  ${({ $disabled = false }) =>
    $disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

export const DomainHandleCompanyInline = styled.span`
  color: var(--text-muted);
  font-weight: 400;
`;

export const DomainHandlePrimary = styled.div`
  font-weight: 600;
  font-size: var(--font-size);
  line-height: 1.3;
`;

export const DomainHandleSecondary = styled.div`
  font-size: var(--font-size);
  color: var(--text-muted);
  line-height: 1.3;
`;

/**
 * Meta information layout.
 */
export const DomainHandleMetaRow = styled.div`
  margin-top: 4px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const DomainHandleMetaItem = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  align-items: center;
  column-gap: 8px;
  min-width: 220px;
  font-size: var(--sm-font-size);
  color: var(--text-muted);
  line-height: 1.2;
`;

export const DomainHandleMetaLine = styled.div`
  margin-top: 2px;
  display: grid;
  grid-template-columns: 16px 1fr;
  align-items: center;
  column-gap: 8px;
  font-size: var(--sm-font-size);
  color: var(--text-muted);
  line-height: 1.2;
`;

export const DomainHandleMetaIcon = styled.span`
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const DomainHandleMetaText = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/**
 * Selected value (SingleValue) styling.
 */
export const DomainHandleSingleValue = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
`;

export const DomainHandleSinglePrimary = styled.span`
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DomainHandleSingleSecondary = styled.span`
  color: var(--text-muted);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
